<script setup lang="ts"></script>
<template>
    <div class="mx-auto max-w-[85rem] px-4 py-10 sm:px-6 lg:px-8 lg:py-14">
        <div class="text-center">
            <h1 class="mt-2 text-5xl font-bold text-primary-500">Kontakt</h1>
        </div>
        <div class="py-28 text-center">BlaBla Daten BlaBla</div>
    </div>
</template>
